module.exports = __webpack_public_path__ + "media/error.45cfdcdb.wav";